import React from "react";
import LiveChatsupport24_7icon from "../assets/LiveChatsupport24_7icon.png";
import helpCenter from "../assets/helpCenter.png";
import { t } from "i18next";

function LearnHowToUseDizlogComponent({ title = "" }) {
  console.log("modal");

  let learnHowItems = [
    {
      icon: LiveChatsupport24_7icon,
      title: t("Live Chat support 24/7"),
      description:
        t("Instantly connect with our dedicated support team through live chat for personalized assistance and prompt resolution of any issues you may have."),
    },
    {
      icon: helpCenter,
      title: t("Help Center"),
      description:
        t("Find answers to your questions, discover useful tips, and stay informed with the latest updates. Get the support you need to thrive through our user-friendly Help Center."),
    },
  ];

  return (
    <>
      <section id="IOFLASLDOIQUWOIU">
        <div className="min-h-[545px] bg-white w-full flex flex-col justify-center items-center gap-4 p-4 md:p-8">
          <div className="flex justify-center items-center flex-col w-full max-w-[1200px] gap-2 px-4">
            <span className="font-[600] font-[Roboto] text-lg sm:text-[20px] text-[#F09000]">
              {t("Enjoying DizLog More")}
            </span>
            <span className="font-[Raleway] font-[700] text-xl sm:text-[45px] text-center text-[#00215D] leading-tight">
              {title == "" ? t("Learn how to use DizLog POS with Pleasure") : title}
            </span>
          </div>
          <div className="flex flex-col md:flex-row gap-4 items-start">
            {learnHowItems.map(item => (
              <div className="flex flex-col w-full min-h-[300px] md:w-1/2 max-w-[565px] justify-end items-center bg-[#F6F6FF] shadow-sm rounded-sm p-4 gap-2">
                <div className="flex flex-col w-full gap-2">
                  <div className="flex justify-start w-full">
                    <img
                      src={item.icon}
                      className="h-[80px] w-[80px]"
                    />
                  </div>
                  <span className="font-[Raleway] font-[700] text-[24px] text-[#00215D]">
                    {item.title}
                  </span>
                </div>
                <span className="font-[Roboto] text-[15px] font-[400] text-[#6B6B6B] leading-[25px] flex-1">
                  {item.description}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default LearnHowToUseDizlogComponent;
